module.exports = __webpack_public_path__ + "static/Abacus Arbeitszeugnis LEHMANNPARTNER-ae21abce952173380f71413398e188cc.pdf";